(() => {
  if (window.VastraaniiWishlist) return;
  const key = 'myWishlist';
  const clean = (value) => Array.isArray(value)
    ? [...new Set(value.filter(handle => typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(handle)))]
    : [];
  const read = () => {
    try { return clean(JSON.parse(localStorage.getItem(key) || '[]')); }
    catch { return []; }
  };
  const sync = () => {
    const handles = read();
    const bubble = document.getElementById('wishlist-count');
    if (bubble) {
      bubble.hidden = handles.length === 0;
      bubble.textContent = String(handles.length);
    }
    document.querySelectorAll('.wishlist-btn[data-product-handle]').forEach(button => {
      const saved = handles.includes(button.dataset.productHandle);
      button.classList.toggle('wished', saved);
      button.setAttribute('aria-pressed', String(saved));
    });
  };
  const write = (handles) => {
    try { localStorage.setItem(key, JSON.stringify(clean(handles))); }
    catch { return false; }
    sync();
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
    return true;
  };
  const toggle = (handle) => {
    const handles = read();
    return write(handles.includes(handle) ? handles.filter(item => item !== handle) : [...handles, handle]);
  };
  window.VastraaniiWishlist = { read, write, toggle, sync };
  window.updateHeaderWishlistCount = sync;
  // Keep the accessible theme account control connected to the store's login app.
  // When the app is unavailable, the native Shopify account control still works.
  document.addEventListener('click', event => {
    const account = event.target.closest?.('#header-component .account-button, #header-component [data-vst-account-link]');
    if (!account || typeof window.handleKpAndShopifyLogin !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    const drawer = account.closest('header-drawer');
    const details = drawer?.querySelector('details');
    if (details?.open && typeof drawer.close === 'function') {
      // Release the menu focus trap before opening the account app's dialog.
      const openAccount = () => {
        if (details.open) return;
        details.removeEventListener('toggle', openAccount);
        window.handleKpAndShopifyLogin();
      };
      details.addEventListener('toggle', openAccount);
      drawer.close();
      return;
    }
    window.handleKpAndShopifyLogin();
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('.wishlist-btn[data-product-handle]');
    if (!button) return;
    event.preventDefault();
    const success = toggle(button.dataset.productHandle);
    const status = document.getElementById('VastraaniiWishlistStatus');
    if (status) status.textContent = success
      ? (read().includes(button.dataset.productHandle) ? 'Saved to your wishlist.' : 'Removed from your wishlist.')
      : 'Your browser could not save this item. Please allow site storage and try again.';
  });
  document.addEventListener('wishlist:updated', sync);
  window.addEventListener('wishlist:updated', sync);
  window.addEventListener('storage', event => {
    if (event.key === key || event.key === null) {
      sync();
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }
  });
  document.addEventListener('shopify:section:load', sync);
  let queued = false;
  const start = () => {
    sync();
    const main = document.getElementById('MainContent');
    if (!main) return;
    new MutationObserver(records => {
      if (queued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('.wishlist-btn') || node.querySelector?.('.wishlist-btn'))))) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; sync(); });
    }).observe(main, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
